import React from "react";

export default function FourColorBoxComp({ colors }) {
  // console.log(colors);
  return (
    <main className="flex items-center justify-center w-full">
      {colors.map((color, index) => (
        <div
          key={index}
          style={{
            backgroundColor: color,
            width: "20px",
            height: "20px",
          }}
        ></div>
      ))}
    </main>
  );
}
